import React, { useEffect, useState } from 'react';
import { Shield } from 'lucide-react';
import DataTable from '../../components/DataTable';
import { PageHeader } from '../../components/UI';
import { auditService } from '../../api/services';
import { toJalaliDateTime } from '../../utils/jalali';
import toast from 'react-hot-toast';

export default function AuditPage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    auditService.getAll({ page, limit: 50 })
      .then(r => { setData(r.data.data || []); setTotal(r.data.pagination?.total || 0); })
      .catch(() => toast.error('Failed to load audit logs'))
      .finally(() => setLoading(false));
  }, [page]);

  const columns = [
    { key: 'user', label: 'User', render: (v) => v?.name || 'System' },
    { key: 'action', label: 'Action' },
    { key: 'module', label: 'Module', render: (v) => v ? <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded text-xs font-medium">{v}</span> : '-' },
    { key: 'description', label: 'Description' },
    { key: 'ipAddress', label: 'IP Address' },
    { key: 'createdAt', label: 'Timestamp', render: (v) => toJalaliDateTime(v) },
  ];

  return (
    <div>
      <PageHeader
        title="Audit Logs"
        subtitle="System activity and security logs"
      />
      <DataTable
        columns={columns}
        data={data}
        loading={loading}
        totalItems={total}
        page={page}
        pageSize={50}
        onPageChange={setPage}
        title="Audit Logs"
        exportFilename="audit_logs"
      />
    </div>
  );
}
